module.exports = __webpack_public_path__ + "static/IMG_4976-f07d4d7dcf5e670f9bb0c38579f789d4.jpg";